var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_c('check-box-manager',{staticClass:"my-2 filter-category-1-check-box-manager",attrs:{"CheckBoxItems":_vm.categories,"label":"انتخاب دسته بندی","selectedCheckBoxes":_vm.selectedCategory,"validation":_vm.$v.selectedCategory}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }